// extracted by mini-css-extract-plugin
export default {"departments":"nF-z","departmentHeading":"oF-z","departmentSection":"pF-z","departmentName":"qF-z","departmentLink":"rF-z","expandIcon":"sF-z"};